import React from 'react';
import colourPaletteCatalog from './colourPaletteCatalog.json';
import { displaySwatchFor } from './swatchColours';
import { SEASON_NAMES, seasonPalette } from './seasonPalette';

// This diagnostic is reachable on non-canonical preview hosts. It lets us
// inspect the complete deployed swatch catalogue without creating a report.
export default function ColourCatalogueCheck() {
  return <main style={{ padding: 24, fontFamily: 'sans-serif' }}>
    <h1>Colour catalogue check</h1>
    <section aria-label="Fixed analyser catalogue">
      <h2>Fixed analyser catalogue</h2>
      {Object.entries(colourPaletteCatalog).map(([name, hex]) => <div key={name} data-colour-tile="fixed" data-expected-hex={hex} style={{ display: 'inline-block', margin: 6, width: 120 }}>
        <span aria-hidden="true" style={{ display: 'block', width: 120, height: 80, background: displaySwatchFor(name, { name, hex: '#000000' }) }} />
        <span>{name}</span>
      </div>)}
    </section>
    {SEASON_NAMES.map((season) => <section key={season} aria-label={`${season} guide`}>
      <h2>{season}</h2>
      {[...seasonPalette(season).best, ...seasonPalette(season).caution].map(({ key, name, hex }, index) => <div key={`${key}-${index}`} data-colour-tile="season" data-expected-hex={hex} style={{ display: 'inline-block', margin: 6, width: 120 }}>
        <span aria-hidden="true" style={{ display: 'block', width: 120, height: 80, background: hex }} />
        <span>{name}</span>
      </div>)}
    </section>)}
  </main>;
}
